import React from 'react';
import { connectToDevTools } from 'react-devtools-core';
import { LogBox } from 'react-native';
import { StatusBar } from 'expo-status-bar';

import { ErrorBoundary } from '@order/components';
import { initDatadog } from '@order/integrations';
import { UrqlProvider } from '@order/Urql';
import {
  fixAndroidKeyboardLayoutShifts,
  fixIosFullHeightIssue,
  getEnvVars,
} from '@order/utils';

import { App } from './App';
import { intlPolyfill } from './polyfills';
import { Providers } from './Providers';

const { ENABLE_FLIPPER } = getEnvVars();

if (ENABLE_FLIPPER === 'true' && __DEV__) {
  connectToDevTools({
    host: 'localhost',
    port: 8097,
  });
}

// FIXME we need to fix the underlying issue for Android; this is here so that Android e2e tests can pass.
// The warning it is hiding is covering UI elements the test runner is trying to interact with.
LogBox.ignoreAllLogs();

intlPolyfill();
void initDatadog();
fixIosFullHeightIssue();
fixAndroidKeyboardLayoutShifts();

export const Root = () => (
  <ErrorBoundary>
    <UrqlProvider>
      <Providers>
        <App />
        <StatusBar animated />
      </Providers>
    </UrqlProvider>
  </ErrorBoundary>
);
